import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  SnackbarContent,
  TextField,
  Typography,
} from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import {
  ExpandLess,
  ExpandMore,
  VerticalAlignBottom,
  VerticalAlignTop,
} from "@material-ui/icons";
import RadioButtonUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import RemoveIcon from "@material-ui/icons/Remove";
import { DateTime } from "luxon";
import React, { FC, useEffect, useRef } from "react";
import { getFirstFlg, getFixedFlg, getReadFixedFlg } from "../../Header/Header";
import DatePicker from "../../common/DatePicker";
import TenpoCheckDialog from "../TenpoCheckDialog";
import { updateScore } from "./TenpoCheckCalculation";
import TenpoCheckModalButton from "./TenpoCheckModalButton";
import TenpoCheckModalManual from "./TenpoCheckModalManual";
import TenpoCheckSelect from "./TenpoCheckSelect";
import {
  TENPO_CHECK_ADD_BIG_RECORD,
  TENPO_CHECK_ADD_RECORD,
  TENPO_CHECK_BIG_RECORD,
  TENPO_CHECK_DATA,
  TENPO_CHECK_RECORD,
  createNewRecord,
  deleteAddItems,
  getFirstDayOfWeek,
  getTenpoCheckData,
  getTenpoCheckRecordsFirestoreData,
  getTenpoCheckRenkeiData,
  sortAddItems,
  updateTenpoCheck,
  updateTenpoCheckAddItem,
  updateTenpoCheckAddValue,
  updateTenpoCheckFirestore,
  updateTenpoCheckTotalImageSize,
} from "./TenpoCheckTableDataOperation";

import { useSelector } from "react-redux";
import { postRequest } from "../../../apis/axiosAction";
import { getJobCategoryFromCode, isOfcCheck, isWorkProgress } from "../../../apis/privilege";
import { userLogging } from "../../../apis/userLog";
import { selectUser } from "../../../features/userSlice";
import TimeDatePicker from "../../common/TimeDatePicker";
import { stylesTenpoCheckTable } from "./StylesTenpoCheckRegister";
import TenpoCheckModalLastScore from "./TenpoCheckModalLastScore";
import TenpoCheckTemplateModalButton from "./TenpoCheckTemplateModalButton";

// 画面項目の変更フラグ
let changeFlg = false;
export function getChangeFlg() {
  return changeFlg;
}
export function setChangeFlg(flg: boolean) {
  changeFlg = flg;
}

// 天候リスト
const weatherList = [
  { name: "晴れ", code: "1" },
  { name: "曇り", code: "2" },
  { name: "雨", code: "3" },
  { name: "雪", code: "4" },
];
// 全角数字半角変換
function zenkakuReplace(str: string) {
  return str.replace(/[０-９．]/g, function (s: string) {
    let result = String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    return result;
  });
}

// 曜日の取得
const getDayOfWeekText = (datetime: DateTime | null) => {
  if (!datetime) {
    return;
  }
  let weekDayArray: string[] = [];
  weekDayArray = ["月", "火", "水", "木", "金", "土", "日"];
  const dayOfWeek = datetime.weekday;
  return weekDayArray[dayOfWeek - 1];
};

// 作成日付(旧承認日)
let isApprove: number = 0;
export function isApproveDate() {
  return isApprove;
}
function checkApproveDate(dayStr: string | null, lastApproveDay: string) {
  isApprove =
    lastApproveDay !== ""
      ? dayStr && DateTime.fromFormat(dayStr, "yyyyMMdd").isValid
        ? dayStr >= lastApproveDay
          ? 1
          : 0
        : -1
      : dayStr && DateTime.fromFormat(dayStr, "yyyyMMdd").isValid
      ? 1
      : -1;
}
// 作成時間
let isApproveHourInput: number = 0;
export function isApproveHour() {
  return isApproveHourInput;
}
function checkApproveHour(hourStr: string) {
  let hourNum: number = Number(hourStr);
  if (hourNum || (hourStr && hourNum === 0)) {
    isApproveHourInput = hourNum;
  } else {
    isApproveHourInput = -1;
  }
}
// 最初の読み込み時に追い越しが走らないようにするためのフラグ
let initailizeFlag: boolean;
// クリックされたことを判定するカウント
let clickCount = 0;
// 合計スコア（保存処理用）
let totalScore = 0;
// 画像合計サイズ（保存処理用）
let saveGrandTotalImageSize = 0;
// 作成日（保存処理用）
let saveApprovalDate: DateTime | null;

export function getGrandTotalImageSize() {
  return saveGrandTotalImageSize;
}

export function saveTotalImageSizeOnly(tenpoCheckId: string) {
  updateTenpoCheckTotalImageSize(tenpoCheckId, saveGrandTotalImageSize);
}

// バイトをKB、MB、GBに変換する関数
function formatBytes(bytes: number, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const TenpoCheckTable: FC<{
  tenpoCode: string;
  tenpoCheckId: string;
  lastTenpoCheckId: string;
  tenpoName?: string;
}> = ({ tenpoCode, tenpoCheckId, lastTenpoCheckId, tenpoName}) => {
  const classes = stylesTenpoCheckTable();

  const [approvalDate, setApprovalDate] = React.useState<DateTime | null>(null);
  const [lastApprovalDate, setLastApprovalDate] = React.useState("");
  const [lastDateTitle, setLastDateTitle] = React.useState("");

  const [click, setClick] = React.useState(false);
  const [addMode, setAddMode] = React.useState(false);
  const [addValue, setAddValue] = React.useState("");
  const [addOffenseFlg, setAddOffenseFlg] = React.useState("1");
  const [delCkList, setDelCkList] = React.useState([""]);
  const [deleteMode, setDeleteMode] = React.useState(false);
  const [sortMode, setSortMode] = React.useState(false);
  const [checkedId, setCheckedId] = React.useState("");
  const user = useSelector(selectUser);

  const [rowItemList, setRowItemList] = React.useState<
    TENPO_CHECK_BIG_RECORD[]
  >([]);
  const [addRowItemList, setAddRowItemList] = React.useState<
    TENPO_CHECK_ADD_BIG_RECORD[]
  >([]);
  const [selectedTenpoCode, setSelectedTenpoCode] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const scrollBottomRef = useRef<HTMLDivElement>(null);
  const [scrollSwitch, setScrollSwitch] = React.useState(false);
  const [userPrivilege, setUserPrivilege] = React.useState("");
  const [ofcFlg, setOfcFlg] = React.useState(false);
  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [tenpoCodeSpecialList, setTenpoCodeSpecialList] = React.useState<string[]>([]);

  const [dialogFlg, setDialogFlg] = React.useState(false);
  const dialogClose = () => {
    setDialogFlg(false);
  };
  const [openAlert, setOpenAlert] = React.useState(false);
  const [approveWeather, setApproveWeather] = React.useState("");
  const [inputHour, setInputHour] = React.useState("");
  const [approveHour, setApproveHour] = React.useState("");
  const [openTemplateEditAlert, setOpenTemplateEditAlert] = React.useState(false);
  const [grandTotalImageSize, setGrandTotalImageSize] = React.useState(0);

  const [wariateCount, setWariateCount] = React.useState(0);
  
  // 天候
  const weatherChangeDo = (event: React.ChangeEvent<{ value: unknown }>) => {
    setApproveWeather(event.target.value as string);
    setChangeFlg(true);
  };
  // タスク連携リスト
  const [displayRenkeiList, setDisplayRenkeiList] = React.useState<any>([]);
  const [lastRenkeiList, setLastRenkeiList] = React.useState<any>([]);

  // 時間入力フィールド
  const InputHourField: React.FC<{
    hour: string;
    blurEvent: (manHour: string) => void;
    fixedFlg: boolean;
  }> = ({ hour, blurEvent, fixedFlg }) => {
    const [inputHour, setInputHour] = React.useState(hour);

    const changeHoure = (date: DateTime | null) => {
      if (date) {
        setInputHour(String(date.hour));
        setChangeFlg(true);
        blurEvent(String(date.hour));
      }
    };

    return (
      <>
        {!fixedFlg ? (
          <FormGroup row>
              <TimeDatePicker
                timeFunc={(date: DateTime | null) => {
                  changeHoure(date);
                }}
                timeValue={inputHour}
                width="100px"
                views={["hours"]}
                format="H時"
              />
          </FormGroup>
        ) : (
          <Typography variant="h6" style={{ marginLeft: "10px" }}>
            {inputHour ? inputHour + "時" : ""}
          </Typography>
        )}
      </>
    );
  };

  const blurHour = (hour: string) => {
    setInputHour(hour);
    setApproveHour(String(hour));
    checkApproveHour(hour);
    setChangeFlg(true);
  };

  const alertClick = () => {
    setOpenAlert(!openAlert);
  };

  const alertTemplateEditClick = () => {
    setOpenTemplateEditAlert(!openTemplateEditAlert);
  };

  useEffect(() => {
    setRowItemList([]);
    setAddRowItemList([]);
    setApprovalDate(null);
    saveApprovalDate = null;
    setChangeFlg(false);
    initailizeFlag = false;
    if (getFirstFlg()) {
      setSelectedTenpoCode("");
    } else {
      setSelectedTenpoCode(tenpoCode);
    }
  }, [tenpoCode, getFirstFlg()]);

  useEffect(() => {
    if (loading === true || !tenpoCheckId){
      setRowItemList([]);
      setAddRowItemList([]);
      setApprovalDate(null);
      saveApprovalDate = null;
      setChangeFlg(false);
      initailizeFlag = false;
      setSelectedTenpoCode("");
      setGrandTotalImageSize(0);
      return;
    }
    setLoading(true);
    userLogging("店舗確認表", "新規作成#初期表示", tenpoCheckId);
    setUserPrivilege(getJobCategoryFromCode(user));
    setTenpoCodeSpecialList(user.tenpoCodeSpecialList);

    setRowItemList([]);
    setAddRowItemList([]);
    initailizeFlag = false;
    setSelectedTenpoCode(tenpoCode);
    let ofcFlg = false;
    if (isOfcCheck(user, tenpoCode)) {
      ofcFlg = true;
    }
    setOfcFlg(ofcFlg);
    getTenpoCheckData(
      tenpoCode,
      tenpoCheckId,
      lastTenpoCheckId,
      getFixedFlg(),
      getJobCategoryFromCode(user),
      ofcFlg
    ).then((res: TENPO_CHECK_DATA) => {
      setApprovalDate(
        res.approve_day
          ? DateTime.fromFormat(res.approve_day, "yyyyMMdd")
          : DateTime.local()
      );
      saveApprovalDate = res.approve_day
        ? DateTime.fromFormat(res.approve_day, "yyyyMMdd")
        : DateTime.local();
      checkApproveDate(
        res.approve_day ? res.approve_day : "",
        res.last_approve_day
      );
      if (res.approve_day) {
        // setChangeFlg(false);
      } else {
        setChangeFlg(true);
      }
      if (res.approve_weather) {
        setApproveWeather(res.approve_weather);
      } else {
        setApproveWeather("");
      }
      checkApproveHour(res.approve_hour);
      if (res.approve_hour) {
        setInputHour(res.approve_hour);
        setApproveHour(res.approve_hour);
      } else {
        setInputHour("");
        setApproveHour("");
      }
      setLastApprovalDate(res.last_approve_day);
      setLastDateTitle(
        res.last_approve_day
          ? DateTime.fromFormat(res.last_approve_day, "yyyyMMdd").toFormat(
              "MM月dd日"
            )
          : "-"
      );
      if (res.lastRenkeiList) {
        setLastRenkeiList(res.lastRenkeiList);
      } else {
        setLastRenkeiList([]);
      }
      setRowItemList(res.base_value);
      setAddRowItemList(res.add_value);
      initailizeFlag = true;
      
      setAddMode(false);
      setDeleteMode(false);
      setSortMode(false);
      if (tenpoCheckId) {
        setDisplayRenkeiList(getTenpoCheckRenkeiData(tenpoCheckId));
        updateWariateRenkeiCount(res.base_value);
      }
      handleClick();
    });
  }, [tenpoCheckId]);

  useEffect(() => {
    // 画像サイズの再計算
    if (tenpoCheckId) {
      getTenpoCheckRecordsFirestoreData(tenpoCheckId).then((data: any) => {
        if (data && data.attribution.total_image_size) {
          setGrandTotalImageSize(data.attribution.total_image_size);
        }
      });
    }
  }, [tenpoCheckId]);

  useEffect(() => {
    scrollBottomRef?.current?.scrollIntoView(false);
  }, [scrollSwitch]);

  useEffect(() => {
    // 店舗確認表(基本項目)の値に変更があった時に呼び出されるReactHooks
    // ボタン（○、×、-、削除）が押下される度にも呼び出される。scoreの計算と保存
    if (
      (Array.isArray(addRowItemList) && addRowItemList.length === 0) ||
      (Array.isArray(rowItemList) && rowItemList.length === 0) ||
      !initailizeFlag
    )
      return;
    if (getFixedFlg()) {
      setLoading(false);
      return;
    }
    // 保存のたびにtotalScoreを計算
    const updateTeatAsync = async () => {
      const res = await updateScore(rowItemList, addRowItemList);
      totalScore = res;
      // saveTenpoCheck();
      // updateTenpoCheckAddItem(addRowItemList, selectedTenpoCode, userPrivilege);
      if (tenpoCheckId) {
        setLoading(false);
      }
    }
    updateTeatAsync();
    
    // 画像の合計サイズを計算
    if (!getFixedFlg()) {
      let totalSize = 0;
      const calculateSize = (list: any[]) => {
        list.forEach(bigRecord => {
          bigRecord.rows.forEach((record: any) => {
            if (record.photo_filesize_gcs && Array.isArray(record.photo_filesize_gcs)) {
              totalSize += record.photo_filesize_gcs.reduce((acc: number, size: number) => acc + (size || 0), 0);
            }
            if (record.comment_filesize_gcs && Array.isArray(record.comment_filesize_gcs)) {
              totalSize += record.comment_filesize_gcs.reduce((acc: number, size: number) => acc + (size || 0), 0);
            }
          });
        });
      };
      calculateSize(rowItemList);
      calculateSize(addRowItemList);
      setGrandTotalImageSize(totalSize);
      saveGrandTotalImageSize = totalSize;
    }
  }, [rowItemList, addRowItemList, clickCount]);

  /**
   * PDFボタン押下時のイベント
   * @param type:number 1:新方式 2:旧方式
   */
  const clickPdfPrint = () => {
    if (!checkInputTenpoCheck()) {
      return;
    }
    if (!approvalDate) {
      return;
    }
    handlePdfPrint();
  }
  const handlePdfPrint = async () => {
    await getTenpoCheckData(
      tenpoCode,
      tenpoCheckId,
      lastTenpoCheckId,
      getFixedFlg(),
      getJobCategoryFromCode(user),
      ofcFlg
    ).then((res: TENPO_CHECK_DATA) => {
      let ckRowItemList: TENPO_CHECK_BIG_RECORD[] = res.base_value;
      let ckAddRowItemList: TENPO_CHECK_ADD_BIG_RECORD[] = res.add_value;

      // 画面の最新状態との比較
      if (
        !approvalDate ||
        approvalDate.toFormat("yyyyMMdd") !== res.approve_day ||
        !checkLatestRecord(rowItemList, ckRowItemList) ||
        !checkLatestRecord(addRowItemList, ckAddRowItemList)
      ) {
        return;
      } else {
        // 次回の店舗確認表のデータを作成
        const apiParams = {
          id: tenpoCheckId,
          approve_day: approvalDate,
          newFlag: true,
        };
        const url =
          process.env.REACT_APP_API_URL_J11SPB22 + "tenpocheck/createPdfTenpoCheck";
        postRequest(url, apiParams);
      }
    });
  };

  function checkInputTenpoCheck() {
    let result = true;
    for (let i = 0; i < rowItemList.length; i++) {
      for (let j = 0; j < rowItemList[i].rows.length; j++) {
        if (
          !rowItemList[i].rows[j].button_value ||
          rowItemList[i].rows[j].button_value === "0"
        ) {
          result = false;
        }
      }
    }
    for (let i = 0; i < addRowItemList.length; i++) {
      for (let j = 0; j < addRowItemList[i].rows.length; j++) {
        if (
          !addRowItemList[i].rows[j].button_value ||
          addRowItemList[i].rows[j].button_value === "0"
        ) {
          result = false;
        }
      }
    }
    return result;
  }

  // 入力値比較
  const checkLatestRecord = (base: any[], check: any[]) => {
    for (let i = 0; i < base.length; i++) {
      if (base[i].rows.length !== check[i].rows.length) {
        return false;
      }
      for (let j = 0; j < base[i].rows.length; j++) {
        let baseRow = base[i].rows[j];
        let checkRow = check[i].rows[j];
        if (
          baseRow.big_item_id !== checkRow.big_item_id ||
          baseRow.button_value !== checkRow.button_value ||
          baseRow.score !== checkRow.score ||
          baseRow.user_input_comment !== checkRow.user_input_comment ||
          baseRow.user_radio_comment !== checkRow.user_radio_comment ||
          baseRow.user_radio_target !== checkRow.user_radio_target ||
          baseRow.small_item_id !== checkRow.small_item_id ||
          baseRow.small_title !== checkRow.small_title
        ) {
          return false;
        }
        for (let k = 0; k < baseRow.photo_filepath_gcs.length; k++) {
          if (
            baseRow.photo_filepath_gcs[k] !== checkRow.photo_filepath_gcs[k]
          ) {
            return false;
          }
        }
      }
    }
    return true;
  };

  const handleClick = () => {
    setClick((prev) => !click);
  };

  const handleApprovalDate = (date: DateTime | null) => {
    if (!initailizeFlag) return date;
    setChangeFlg(true);
    checkApproveDate(date ? date.toFormat("yyyyMMdd") : "", lastApprovalDate);
    setApprovalDate(date);
    saveApprovalDate = date;
    saveTenpoCheck();
    saveAddItems(addRowItemList, selectedTenpoCode, userPrivilege, ofcFlg);
    return date;
  };

  const initApproveDate = () => {
    checkApproveDate(
      approvalDate ? approvalDate.toFormat("yyyyMMdd") : "",
      lastApprovalDate
    );
    if (approvalDate !== null) return approvalDate;
    let date = DateTime.local();
    setApprovalDate(date);
    saveApprovalDate = date;
    return date;
  };
  // ボタン押下処理
  const clickButton = (row: any, n: number) => {
    if (getFixedFlg()) return;

    setChangeFlg(true);
    if (n === 1) {
      if (row.button_value !== "1") {
        row.button_value = "1";
        row.user_radio_comment = "";
        row.user_radio_target = "";
        row.user_ng_list = [];
      }
    }
    if (n === 2) {
      if (row.button_value !== "2") {
        row.button_value = "2";
      }
    }
    if (n === 3) {
      if (row.button_value !== "3") {
        row.button_value = "3";
        row.user_radio_comment = "";
        row.user_radio_target = "";
        row.user_ng_list = [];
      }
    }
    handleClick();
    ++clickCount;
    if (row.big_item_id !== 8) {
      setRowItemList(updateTenpoCheck(rowItemList, row));
    } else {
      setAddRowItemList(
        updateTenpoCheckAddValue(addRowItemList, row as TENPO_CHECK_ADD_RECORD)
      );
    }
    updateWariateRenkeiCount(rowItemList);
    //updateTenpoCheckAddItem(addRowItemList, selectedTenpoCode, userPrivilege);
  };

  // ×ボタン押下処理
  const clickNgButton = (row: any) => {
    if (getFixedFlg()) return;

    setChangeFlg(true);
    if (row.button_value !== "2") {
      row.button_value = "2";
    } else if (!row.user_ng_list || row.user_ng_list.length === 0) {
      row.button_value = "0";
    }
    handleClick();
    ++clickCount;
    if (row.big_item_id !== 8) {
      setRowItemList(updateTenpoCheck(rowItemList, row));
    } else {
      setAddRowItemList(
        updateTenpoCheckAddValue(addRowItemList, row as TENPO_CHECK_ADD_RECORD)
      );
    }
    updateWariateRenkeiCount(rowItemList);
  };

  
  // 営業計画支援システム連携対象の更新用リスト取得
  const getDisplayRenkeiList = (rowList:any[], displayRenkeiList :any[]) => {
    let resultRenkeiList : any = [];
    for (let rowItem of rowList) {
      for (let row of rowItem.rows) {
        for (let ngMap of row.user_ng_list) {
          if (displayRenkeiList && ngMap.task_id) {
            for (let displayRenkeiMap of displayRenkeiList) {
              if (displayRenkeiMap.bigItemId === row.big_item_id && 
                displayRenkeiMap.smallItemId === row.small_item_id && 
                displayRenkeiMap.targetId === ngMap.user_radio_target && 
                displayRenkeiMap.taskId === ngMap.task_id){
                  resultRenkeiList.push(displayRenkeiMap);
              }
            }
          }
        }
      }
    }
    return resultRenkeiList;
  }

  // 営業計画支援システム連携対象の更新
  const updateWariateRenkeiCount = (rowList:any[]) => {
    let renkeiTaskList:any[] = [];
    let workDisplayRenkeiList: any[] = [];
    for (let rowItem of rowList) {
      for (let row of rowItem.rows) {
        for (let ngMap of row.user_ng_list) {
          if (ngMap.task_id && renkeiTaskList.indexOf(ngMap.task_id) === -1) {
            renkeiTaskList.push(ngMap.task_id);
            let renkeiMap = {
              bigItemId: row.big_item_id,
              smallItemId: row.small_item_id,
              targetId: ngMap.user_radio_target,
              taskId: ngMap.task_id,
            };
            workDisplayRenkeiList.push(renkeiMap);
          }
        }
      }
    }
    setWariateCount(renkeiTaskList.length);
    setDisplayRenkeiList(workDisplayRenkeiList);
  }

  // 追加項目の行番号をソート
  const sortAddRow = () => {
    let rowNum: number = 0;
    for (let i = 0; i < addRowItemList[0].rows.length; i++) {
      addRowItemList[0].rows[i].small_item_id = rowNum;
      rowNum++;
    }
    return;
  }
  // 削除対象全チェック判定
  const ckAllDelCheck = () => {
    for (let i = 0; i < addRowItemList[0].rows.length; i++) {
      let targetRow = addRowItemList[0].rows[i];
      if (targetRow.big_item_id === 8 && delCkList.indexOf(targetRow.key) === -1) {
        return false;
      }
    }
    return true;
  }

  // 削除モード削除対象全チェック
  const clickAllDelCheck = () => {
    let dcList = [];
    if (!ckAllDelCheck()) {
      for (let i = 0; i < addRowItemList[0].rows.length; i++) {
        if (addRowItemList[0].rows[i].big_item_id === 10 ||
          addRowItemList[0].rows[i].big_item_id === 11) {
            continue;
        }
        dcList.push(addRowItemList[0].rows[i].key);
      }
    }
    setDelCkList(dcList);
    handleClick();
  };
  // 削除モード削除対象チェック
  const clickDelCheck = (key: string) => {
    let dcList = delCkList;
    if (delCkList.includes(key)) {
      dcList = [];
      for (let i = 0; i < delCkList.length; i++) {
        if (delCkList[i] !== key) {
          dcList.push(delCkList[i]);
        }
      }
    } else {
      dcList.push(key);
    }
    setDelCkList(dcList);
    handleClick();
  };

  // 上移動
  const upClick = () => {
    setChangeFlg(true);
    if (checkedId) {
      userLogging("店舗確認表", "新規作成#並び替え上移動", checkedId);
      const obj = sortAddItems(addRowItemList, true, checkedId);
      setCheckedId(obj.nextKey);
      saveTenpoCheck();
      saveAddItems(
        obj.addRowItemList,
        selectedTenpoCode,
        userPrivilege,
        ofcFlg
      );
      handleClick();
    }
  };
  // 下移動
  const lowClick = () => {
    setChangeFlg(true);
    if (checkedId) {
      userLogging("店舗確認表", "新規作成#並び替え下移動", checkedId);
      const obj = sortAddItems(addRowItemList, false, checkedId);
      setCheckedId(obj.nextKey);
      saveTenpoCheck();
      saveAddItems(
        obj.addRowItemList,
        selectedTenpoCode,
        userPrivilege,
        ofcFlg
      );
      handleClick();
    }
  };
  // 追加ボタンクリック
  const addClick = () => {
    if (addRowItemList[0].rows.length > 19) {
      setDialogMessage(["20項目を超えるため追加できません。"]);
      setDialogFlg(true);
      return;
    }
    if (addValue !== "") {
      userLogging("店舗確認表", "新規作成#追加ボタン処理", addValue);
      const newRecord: TENPO_CHECK_ADD_RECORD = createNewRecord(
        addValue,
        addRowItemList[0],
        [],
        [],
        "",
        [],
        [],
        "",
        "low",
        undefined,
        addOffenseFlg
      );
      const newAddRecord: TENPO_CHECK_ADD_BIG_RECORD[] =
        updateTenpoCheckAddValue(addRowItemList, newRecord, true);
      setAddRowItemList(newAddRecord);
      saveAddItems(addRowItemList, selectedTenpoCode, userPrivilege, ofcFlg);
      saveTenpoCheck();
      setAddValue("");
      setAddOffenseFlg("1");
      setChangeFlg(true);
    }
    sortAddRow();
    handleClick();
    setScrollSwitch(!scrollSwitch);
  };

  // テンプレートによる項目追加
  const onTemplateClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    templeteItems: any[],
    isTemplate?: boolean
  ) => {
    if (addRowItemList[0].rows.length + templeteItems.length > 20) {
      setDialogMessage(["20項目を超えるため追加できません。"]);
      setDialogFlg(true);
      return;
    }
    let addRowItem: any[] = [];
    for (let i = 0; i < templeteItems.length; i++) {
      let addFlg = true;
      if (addRowItemList[0]) {
        for (let j = 0; j < addRowItemList[0].rows.length; j++) {
          if (templeteItems[i].name === addRowItemList[0].rows[j].small_title) {
            addRowItemList[0].rows[j].offense_flg = templeteItems[i].offense_flg || "1";
            addFlg = false;
            break;
          }
        }
      }
      if (addFlg) {
        addRowItem.push(templeteItems[i]);
      }
    }
    for (let i = 0; i < addRowItem.length; i++) {
      const newRecord: TENPO_CHECK_ADD_RECORD = createNewRecord(
        addRowItem[i].name,
        addRowItemList[0],
        addRowItem[i].photo_filepath_gcs,
        addRowItem[i].photo_filesize_gcs || [],
        addRowItem[i].user_input_comment,
        addRowItem[i].comment_filepath_gcs,
        addRowItem[i].comment_filesize_gcs,
        addRowItem[i].comment_handwrite_flag,
        addRowItem[i].quality_level,
        addRowItem[i].uuid,
        addRowItem[i].offense_flg,
        true,
        1
      );
      const newAddRecord: TENPO_CHECK_ADD_BIG_RECORD[] =
        updateTenpoCheckAddValue(addRowItemList, newRecord, true);
      setAddRowItemList(newAddRecord);
    }
    saveAddItems(addRowItemList, selectedTenpoCode, userPrivilege, ofcFlg);
    saveTenpoCheck();
    setChangeFlg(true);

    sortAddRow();
    handleClick();
    setScrollSwitch(!scrollSwitch);
  };

  //削除ボタン処理
  const deleteClick = () => {
    if (delCkList.length > 0) {
      setChangeFlg(true);
    }
    userLogging(
      "店舗確認表",
      "新規作成#削除ボタン処理",
      JSON.stringify(delCkList)
    );
    const result: TENPO_CHECK_ADD_BIG_RECORD[] = deleteAddItems(
      delCkList,
      addRowItemList
    );
    setAddRowItemList(result);
    saveTenpoCheck();
    saveAddItems(addRowItemList, selectedTenpoCode, userPrivilege, ofcFlg);

    if (addRowItemList && addRowItemList[0].rows.length === 0) {
      setDeleteMode(false);
    }
    setDelCkList([]);
    sortAddRow();
    handleClick();
    ++clickCount;
  };
  // 追加モードへ
  const addModeClick = () => {
    userLogging("店舗確認表", "新規作成#項目追加", "");
    if (getFixedFlg()) return;

    setAddMode((prev) => !prev);
    setDeleteMode(false);
    setSortMode(false);
  };
  // 削除モードへ
  const deleteModeClick = () => {
    userLogging("店舗確認表", "新規作成#項目削除", "");
    if (getFixedFlg()) return;

    setDelCkList([]);
    setDeleteMode((prev) => !prev);
    setAddMode(false);
    setSortMode(false);
    if (!deleteMode) {
      setOpenTemplateEditAlert(true);
    }
  };
  // 並べ替えモードへ
  const sortModeClick = () => {
    userLogging("店舗確認表", "新規作成#並び替え", "");
    if (getFixedFlg()) return;

    setCheckedId("");
    setSortMode((prev) => !prev);
    setAddMode(false);
    setDeleteMode(false);
    if (!sortMode) {
      setOpenTemplateEditAlert(true);
    }
  };
  // 保存ボタンクリック処理
  const clickConfirmButton = () => {
    userLogging("店舗確認表", "新規作成#保存ボタン", "");
    if (getFixedFlg()) return;

    if (grandTotalImageSize > 9 * 1000 * 1000) {
      setDialogMessage([
        "帳票サイズが10MBを超えます",
        "※提出・保存はできます",
        "※10MBを超えるとネットプリントに登録できません",
      ]);
      setDialogFlg(true);
    }

    if (!initailizeFlag) return;
    //保存処理
    setChangeFlg(false);
    setAddMode(false);
    setDeleteMode(false);
    setSortMode(false);
    saveTenpoCheck();
    saveAddItems(addRowItemList, selectedTenpoCode, userPrivilege, ofcFlg);
    clickPdfPrint();
    handleClick();
  };
  const onPhotoClick = (
    row: TENPO_CHECK_RECORD,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    comment: string,
    filePath: string[],
    fileSize: number[],
    commentFilepathGcs: string[],
    commentFilesizeGcs: number[],
    commentHandwriteFlag: string,
    qualityLevel: string,
    templateFlag: number,
  ) => {
    console.log("onPhotoClick - template_flag:", templateFlag);
    userLogging("店舗確認表", "新規作成#写真ダイアログ保存ボタン", "");
    row.photo_filepath_gcs = filePath;
    row.photo_filesize_gcs = fileSize || [];
    row.user_input_comment = comment;
    row.comment_filepath_gcs = commentFilepathGcs;
    row.comment_filesize_gcs = commentFilesizeGcs;
    row.comment_handwrite_flag = commentHandwriteFlag;
    (row as any).quality_level = qualityLevel;
    (row as any).template_flag = templateFlag;

    const updateItems = (items: any[]) =>
      items.map((bigRecord) => ({
        ...bigRecord,
        rows: bigRecord.rows.map((record: any) => {
          if (record.key === row.key) {
            return {
              ...record,
              photo_filepath_gcs: filePath,
              photo_filesize_gcs: fileSize || [],
              user_input_comment: comment,
              comment_filepath_gcs: commentFilepathGcs,
              comment_filesize_gcs: commentFilesizeGcs,
              comment_handwrite_flag: commentHandwriteFlag,
              quality_level: qualityLevel,
              template_flag: templateFlag,
            };
          }
          return record;
        }),
      }));

    setRowItemList(updateItems(rowItemList));
    setAddRowItemList(updateItems(addRowItemList));
    saveTenpoCheck();
    saveAddItems(addRowItemList, selectedTenpoCode, userPrivilege, ofcFlg);
    clickPdfPrint();
    handleClick();
  };

  // 画面スクロール
  const moveScroll = (fieldName: string, bottomFlg?: boolean) => {
    let element = document?.getElementById(fieldName);
    if (element !== null) {
      if (bottomFlg) {
        element?.scrollIntoView(false);
      } else {
        element.scrollIntoView();
      }
    }
  };

  // 項目追加入力フィールド
  const InputAddItemField: React.FC<{
    comment: string;
    offenseFlg: string;
    blurEvent: (comment: string, offenseFlg: string) => void;
  }> = ({ comment, offenseFlg, blurEvent }) => {
    const [inputComment, setInputComment] = React.useState(String(comment));
    const [inputOffenseFlg] = React.useState(String(offenseFlg));
    const changeComment = (event: React.ChangeEvent<{ value: unknown }>) => {
      setInputComment(event.target.value as string);
    };
    const blurComment = (e: any) => {
      const relatedTarget = e.relatedTarget;
      if (relatedTarget && relatedTarget.type === 'radio') {
        // ラジオボタンに移動するなら何もしない
        return;
      }
      blurEvent(String(inputComment), String(inputOffenseFlg));
    };
    const clickInput = (val: string) => {
      blurEvent(String(inputComment), String(val));
    };

    return (
      <Grid container>
        <Grid item>
        <TextField
          label="追加したい項目"
          placeholder="項目名を入力"
          size="small"
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          className={classes.addText}
          value={inputComment}
          onBlur={(e) => blurComment(e)}
          onChange={(event) => changeComment(event)}
        />
        </Grid>
      </Grid>
    );
  };

  // 保存処理
  const saveTenpoCheck = async () => {
    if (getFixedFlg()) return;

    // 既に完了している場合は更新しない
    const tenpoCheckData: any = await getTenpoCheckRecordsFirestoreData(tenpoCheckId);
    if (tenpoCheckData && tenpoCheckData.attribution.complete_date) return;

    let resultDisiplayRenkeiList = getDisplayRenkeiList(rowItemList, displayRenkeiList);

    sortAddRow();

    // console.log("--- 保存直前のtemplate_flag ---");
    // const logTemplateFlags = (list: any[], listName: string) => {
    //   list.forEach(bigRecord => {
    //     bigRecord.rows.forEach((row: any) => {
    //       console.log(`${listName} - ${row.small_title}:`, (row as any).template_flag);
    //     });
    //   });
    // };
    // logTemplateFlags(rowItemList, "通常項目");
    // logTemplateFlags(addRowItemList, "追加項目");
    // console.log("--------------------------");

    updateTenpoCheckFirestore(
      rowItemList,
      addRowItemList,
      tenpoCheckId,
      totalScore,
      grandTotalImageSize,
      lastTenpoCheckId,
      selectedTenpoCode,
      saveApprovalDate ? saveApprovalDate.toFormat("yyyyMMdd") : "",
      lastApprovalDate ? lastApprovalDate : "",
      userPrivilege,
      approveWeather,
      approveHour,
      tenpoCodeSpecialList,
      resultDisiplayRenkeiList,
      undefined // imageLayoutは現在TenpoCheckResultPrintで管理されているため、undefinedを渡す
    );
  };

  // 追加項目保存処理
  const saveAddItems = async (
    addRowItemList: TENPO_CHECK_ADD_BIG_RECORD[],
    tenpoCode: string,
    userPrivilege: string,
    ofcFlg: boolean
  ) => {
    // 既に完了している場合は更新しない
    const tenpoCheckData: any = await getTenpoCheckRecordsFirestoreData(tenpoCheckId);
    if (tenpoCheckData && tenpoCheckData.attribution.complete_date) return;

    updateTenpoCheckAddItem(addRowItemList, tenpoCode, userPrivilege, ofcFlg);
  };

  const getCheckRecord = (isAddRow: boolean, rowItem: any, index: number) => {
    return (
      <>
        {Object.keys(rowItem.rows).length !== 0 ? (
          <>
            {/* 大項目名↓ここから */}
            <Grid container justify="center" className={classes.header}>
              {isAddRow ? (
                <>
                  {getFixedFlg() ? (
                    <Grid container justify="center">
                      <Typography variant="h4">{rowItem.big_title}</Typography>
                    </Grid>
                  ) : (
                    <>
                      <Grid container item xs={7}>
                        <Grid container justify="flex-end">
                          <Typography variant="h4">
                            {rowItem.big_title}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container item xs={5}>
                        <Grid container justify="flex-end">
                          <Grid item className={classes.buttonSpace}>
                            <Button
                              variant={deleteMode ? "outlined" : "contained"}
                              onClick={() => deleteModeClick()}
                            >
                              項目削除
                            </Button>
                          </Grid>
                          <Grid item className={classes.buttonSpace}>
                            <Button
                              variant={sortMode ? "outlined" : "contained"}
                              onClick={() => sortModeClick()}
                            >
                              並べ替え
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </>
              ) : (
                <Grid container justify="center">
                  <Typography variant="h4">{rowItem.big_title}</Typography>
                </Grid>
              )}
            </Grid>
            {/* 大項目名↑ここまで */}
            <Grid container className={classes.tabBase}>
              {/* タイトル行↓ここから */}
              <Grid container>
                {isAddRow && deleteMode ? (
                  <>
                    <Grid item xs={1}>
                      <Grid item className={classes.columnHeader}>
                        <Grid
                          container
                          className={classes.headerHeight}
                          justify="center"
                          alignItems="center"
                        >
                          <Checkbox
                            style={{ color: "black" }}
                            onChange={() => clickAllDelCheck()}
                            checked={ckAllDelCheck()}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      <Grid item className={classes.columnHeader}>
                        <Grid
                          container
                          className={classes.headerHeight}
                          justify="center"
                          alignItems="center"
                        >
                          <Typography variant="h6">チェック項目</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={7}>
                    <Grid item className={classes.columnHeader}>
                      <Grid
                        container
                        className={classes.headerHeight}
                        justify="center"
                        alignItems="center"
                      >
                        <Typography variant="h6">チェック項目</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                <Grid item xs={1}>
                  <Grid item className={classes.columnHeader}>
                    <Grid
                      container
                      className={classes.headerHeight}
                      justify="center"
                      alignItems="center"
                    >
                      <Typography variant="h6">前回</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={3}>
                  <Grid item className={classes.columnHeader}>
                    <Grid
                      container
                      className={classes.headerHeight}
                      justify="center"
                      alignItems="center"
                    >
                      <Typography variant="h6">今回</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={1}>
                  <Grid item className={classes.columnHeader}>
                    <Grid
                      container
                      className={classes.headerHeight}
                      justify="center"
                      alignItems="center"
                    >
                      <Typography variant="h6">添付</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {/* タイトル行↑ここまで */}
              {/* データ行↓ここから */}
              <Grid container>
                {rowItem.rows.map((row: any, indexRowItem: number) => (
                  <>
                    {/* チェック項目↓ここから */}
                    <Grid item xs={7} key={row.key + "_caption"}>
                      {isAddRow && row.big_item_id === 8 && sortMode ? (
                        <>
                          <Grid
                            item
                            className={classes.columnResult}
                            key={row.key + "_caption_A"}
                          >
                            <Grid
                              container
                              className={classes.columnHeight}
                              alignItems="center"
                            >
                              <Radio
                                id="sort"
                                name="sort"
                                onClick={() => setCheckedId(row.key)}
                                checked={
                                  row.key + "" === checkedId ? true : false
                                }
                              />
                              <Typography>{row.small_title}</Typography>
                            </Grid>
                          </Grid>
                        </>
                      ) : isAddRow && row.big_item_id === 8 && deleteMode ? (
                        <>
                          <Grid
                            item
                            className={classes.columnResult}
                            key={row.key + "_caption_B"}
                          >
                            <Grid
                              container
                              className={classes.columnHeight}
                              alignItems="center"
                            >
                              <Checkbox
                                onChange={() => clickDelCheck(row.key)}
                                checked={
                                  delCkList.includes(row.key) ? true : false
                                }
                              />
                              <Typography>{row.small_title}</Typography>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        <Grid
                          item
                          className={classes.columnCaption}
                          key={row.key + "_caption_C"}
                        >
                          <Grid
                            container
                            className={classes.columnHeight}
                            justify="center"
                            alignItems="center"
                            key={row.key + "_caption_C"}
                          >
                            <TenpoCheckModalManual
                              title={ (row.big_item_id === 11 ?
                                  "【全国】" : row.big_item_id === 10 ? "【ZO】" : "") + row.small_title}
                              filePath={row.manual}
                              titleLinkList={row.title_link_list}
                            />
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                    {/* チェック項目↑ここまで */}
                    {/* 前回↓ここから */}
                    <Grid item xs={1} key={row.key + "_result"}>
                      <Grid item className={classes.columnResult}>
                        <Grid
                          container
                          className={classes.columnHeight}
                          justify="center"
                          alignItems="center"
                        >
                          {row.last_button_value === "1" ||
                           row.last_button_value === "2" ? (
                            <>
                              <TenpoCheckModalLastScore
                                title={row.small_title}
                                comment={row.last_user_input_comment || ""}
                                record={row}
                                lastRenkeiList={lastRenkeiList}
                                photoFilePath={
                                  row.last_photo_filepath_gcs || []
                                }
                              />
                            </>
                          ) : row.last_button_value === "3" ? (
                            <RemoveIcon />
                          ) : (
                            ""
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* 前回↑ここまで */}
                    {/* 今回↓ここから */}
                    <Grid item xs={3} key={row.key + "_check"}>
                      <Grid item className={classes.columnData}>
                        <Grid container>
                          <Grid item xs={4}>
                            <Grid
                              container
                              className={classes.columnHeight}
                              justify="center"
                              alignItems="center"
                            >
                              <Avatar
                                className={
                                  classes.gray +
                                  " " +
                                  (row.button_value === "1" ? classes.mark : "")
                                }
                                onClick={() => console.log("a1")}
                              >
                                <IconButton onClick={() => clickButton(row, 1)}>
                                  <RadioButtonUnchecked />
                                </IconButton>
                              </Avatar>
                            </Grid>
                          </Grid>
                          <Grid item xs={4}>
                            <Grid
                              container
                              className={classes.columnHeight}
                              justify="center"
                              alignItems="center"
                            >
                              <TenpoCheckSelect
                                record={row}
                                reasonChange={(row) => clickNgButton(row)}
                                tenpoCode={selectedTenpoCode}
                                wariateFlg={isWorkProgress(user, tenpoCode)}
                                tenpoName={tenpoName || ""}
                              />
                            </Grid>
                          </Grid>
                          <Grid item xs={4}>
                            <Grid
                              container
                              className={classes.columnHeight}
                              justify="center"
                              alignItems="center"
                            >
                              <Avatar
                                className={
                                  classes.gray +
                                  " " +
                                  (row.button_value === "3" ? classes.mark : "")
                                }
                              >
                                <IconButton onClick={() => clickButton(row, 3)}>
                                  <RemoveIcon />
                                </IconButton>
                              </Avatar>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* 今回↑ここまで */}
                    {/* 添付↓ここから */}
                    <Grid item xs={1} key={row.key + "_upload"}>
                      <Grid className={classes.columnData}>
                        <Grid
                          container
                          justify="center"
                          alignItems="center"
                          key={
                            row.key +
                            row.user_input_comment +
                            row.photo_filepath_gcs[0]
                          }
                        >
                          <TenpoCheckModalButton
                            title={row.small_title}
                            comment={row.user_input_comment}
                            photoFilePath={row.photo_filepath_gcs}
                            photoFileSize={(row as any).photo_filesize_gcs || []}
                            commentFilepath={row.comment_filepath_gcs}
                            commentFilesize={row.comment_filesize_gcs || []}
                            commentHandwrite={row.comment_handwrite_flag}
                            qualityLevel={row.quality_level}
                            templateFlag={(row as any).template_flag}
                            onClickSave={(e, comment, filePath, fileSizes, commentFilepathGcs, commentFilesizeGcs, commentHandwriteFlag, qualityLevel, templateFlag) => {
                              onPhotoClick(row, e, comment, filePath, fileSizes, commentFilepathGcs, commentFilesizeGcs, commentHandwriteFlag, qualityLevel, templateFlag)
                            }}
                            tenpoCode={selectedTenpoCode}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* 添付↑ここまで */}
                  </>
                ))}
              </Grid>
              {/* データ行↑ここまで */}
            </Grid>
          </>
        ) : (
          ""
        )}
      </>
    );
  }

  return (
    <>
      {/* メインコンテンツ↓ここから */}
      <Grid container className={classes.contentFrame}>
        {(loading || getReadFixedFlg()) && (
          <div className={classes.overLayer}></div>
        )}
        {(loading || getReadFixedFlg()) && (
          <CircularProgress className={classes.circularProgress} size={120} />
        )}
        {rowItemList && rowItemList.length > 0 ? (
          <>
            <Grid id="topField" />
            {/* 作成日↓ここから */}
            <Grid container>
              <Grid item lg={6} md={5} sm={4}></Grid>
              <Grid item lg={6} md={7} sm={8}>
                <Grid container justify="center" alignItems="center">
                  <Grid item lg={2} md={2} sm={2}>
                    <Typography variant="h6">作成日</Typography>
                  </Grid>
                  <Grid item justify="center" alignItems="center">
                    {getFixedFlg() ? (
                      approvalDate ? (
                        <Typography variant="h6">
                          {approvalDate.toFormat("yyyy/MM/dd") +
                            "(" +
                            getDayOfWeekText(approvalDate) +
                            ")"}
                        </Typography>
                      ) : (
                        ""
                      )
                    ) : (
                      <DatePicker
                        selectedDate={initApproveDate()}
                        dateFunc={(date: DateTime | null) => {
                          handleApprovalDate(date);
                        }}
                        format={
                          "yyyy年MM月dd日" +
                          "(" +
                          getDayOfWeekText(approvalDate) +
                          ")"
                        }
                        maxDate={DateTime.fromFormat(
                          getFirstDayOfWeek(new Date().toISOString(), 6),
                          "yyyyMMdd"
                        )}
                        minDate={DateTime.fromFormat(
                          getFirstDayOfWeek(new Date().toISOString(), 0),
                          "yyyyMMdd"
                        )}
                        mainColor={"#4dc0b2"}
                      />
                    )}
                  </Grid>
                  <Grid item justify="center" alignItems="center">
                    <InputHourField
                      hour={inputHour}
                      blurEvent={blurHour}
                      fixedFlg={getFixedFlg()}
                    />
                  </Grid>
                  <Grid item justify="flex-end" alignItems="center">
                    <Select
                      value={approveWeather}
                      onChange={(e) => {
                        weatherChangeDo(e);
                      }}
                      style={{
                        minWidth: 70,
                        marginLeft: "10px",
                        color: "#3e3e3e",
                      }}
                      readOnly={getFixedFlg()}
                    >
                      {weatherList.map((row, index) => (
                        <MenuItem value={row.code} key={index}>
                          {row.code !== "" ? (
                            row.name
                          ) : (
                            <em>　　　　　　　　　　　　　　　　　</em>
                          )}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item lg={9} md={8} sm={8}>
                <Grid container justify="flex-end" alignItems="center">
                  <Typography variant="h6">前回作成日</Typography>
                </Grid>
              </Grid>
              <Grid item lg={3} md={4} sm={4}>
                <Grid container justify="center" alignItems="center">
                  <Typography variant="h6">{lastDateTitle}</Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* 作成日↑ここまで */}
          </>
        ) : (
          ""
        )}
        {/* チェック表↓ここから */}
        <Grid container justify="center">
          {/* 追加項目 */}
          {addRowItemList.map((rowItem, index) =>
            getCheckRecord(true, rowItem, index)
          )}
          {getFixedFlg() ? (
            ""
          ) : (
            <Grid
              container
              justify="flex-start"
              className={classes.addbuttonSpace}
              ref={scrollBottomRef}
            >
              <>
                <Grid item xs={4}>
                  {!addMode ? (
                    ""
                  ) : (
                    <>
                      <InputAddItemField
                        comment={addValue}
                        offenseFlg= {addOffenseFlg}
                        blurEvent={(val, flg) =>{
                          setAddValue(val);
                          setAddOffenseFlg(flg);
                          setClick(!click);
                        }}
                      />
                      <Button
                        variant="contained"
                        onClick={() => addClick()}
                        className={classes.editButton}
                      >
                        追加
                      </Button>
                    </>
                  )}
                  {!deleteMode ? (
                    ""
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        onClick={() => deleteClick()}
                        className={classes.editButton}
                      >
                        削除
                      </Button>
                    </>
                  )}
                  {!sortMode ? (
                    ""
                  ) : (
                    <>
                      <IconButton
                        className={classes.upDownButton}
                        onClick={() => upClick()}
                      >
                        <ExpandLess />
                      </IconButton>
                      <IconButton
                        className={classes.upDownButton}
                        onClick={() => lowClick()}
                      >
                        <ExpandMore />
                      </IconButton>
                    </>
                  )}
                </Grid>

                <Grid item xs={8}>
                  <Grid container justify="flex-end">
                    <Grid item className={classes.buttonSpace}>
                      <TenpoCheckTemplateModalButton
                        onClickOK={(e, recordList) =>
                          onTemplateClick(e, recordList)
                        }
                      />
                    </Grid>
                    <Button
                      variant={addMode ? "outlined" : "contained"}
                      onClick={() => addModeClick()}
                    >
                      項目追加
                    </Button>
                  </Grid>
                </Grid>
              </>
            </Grid>
          )}
          {/* 通常項目 */}
          {rowItemList.map((rowItem, index) =>
            getCheckRecord(false, rowItem, index)
          )}
          <Grid id="bottomField" />
        </Grid>

        {/* チェック表↑ここまで */}
      </Grid>
      {/* メインコンテンツ↑ここまで */}
      {/* コンテンツフッター↓ここから */}
      <Grid container alignItems="center" className={classes.footer}>
        <Grid item xs={6}>
          {isWorkProgress(user, tenpoCode) ? (
            <Grid container justify="flex-start" alignItems="center">
              <Typography variant="h6" style={{ fontWeight: "bold", marginRight: "10px" }}>
                営業計画支援システム連携
              </Typography>
              <Typography variant="h6">{wariateCount}項目</Typography>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
        <Grid item xs={6}>
          <Grid container justify="flex-end" alignItems="center">
            <Typography
              variant="body2"
              style={{
                marginRight: "20px",
                fontWeight: "bold",
                color:
                  grandTotalImageSize > 9 * 1000 * 1000 ? "red" : "inherit",
              }}
            >
              画像合計サイズ: {formatBytes(grandTotalImageSize)}
            </Typography>
            <IconButton
              className={classes.upDownButton}
              style={{ color: "#ffffff", backgroundColor: "#00CC5B" }}
              onClick={() => moveScroll("topField")}
            >
              <VerticalAlignTop></VerticalAlignTop>
            </IconButton>
            <IconButton
              className={classes.upDownButton}
              style={{ color: "#ffffff", backgroundColor: "#00CC5B" }}
              onClick={() => moveScroll("bottomField")}
            >
              <VerticalAlignBottom></VerticalAlignBottom>
            </IconButton>
            {getFixedFlg() ? (
              ""
            ) : (
              <>
                <Button
                  variant={"contained"}
                  size="small"
                  color={changeFlg ? "secondary" : "primary"}
                  onClick={() => {
                    clickConfirmButton();
                    alertClick();
                  }}
                >
                  保存
                </Button>
                <Snackbar
                  open={openAlert}
                  autoHideDuration={5000}
                  onClose={alertClick}
                >
                  <SnackbarContent
                    style={{ backgroundColor: "#333333", color: "white" }}
                    message={
                      <span style={{ fontSize: "16px" }}>
                        {"提出（印刷）タブをクリックして店舗確認表を提出してください。"}
                      </span>
                    }
                  />
                </Snackbar>

                <Snackbar
                  open={openTemplateEditAlert}
                  autoHideDuration={5000}
                  onClose={alertTemplateEditClick}
                >
                  <SnackbarContent
                    style={{ backgroundColor: "#333333", color: "white" }}
                    message={
                      <span style={{ fontSize: "16px" }}>
                        {"全国とZOの項目は削除・並べ替えはできません。"}
                      </span>
                    }
                  />
                </Snackbar>
              </>
            )}
            {/* ダイアログ */}
            <TenpoCheckDialog
              msg={dialogMessage}
              isOpen={dialogFlg}
              doOK={dialogClose}
              doNo={dialogClose}
              isAlert={true}
            />
          </Grid>
        </Grid>
      </Grid>
      {/* コンテンツフッター↑ここまで */}
    </>
  );
};
export default TenpoCheckTable;
